var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbs, function (breadcrumb) {
    return _c('b-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to,
        "active": breadcrumb.clickable === false
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("角色相關帳號")])], 2)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.organization.name) + "角色相關帳號 ")]), _c('div', {
    staticClass: "col-12 col-xl-6 d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋員工編號/姓名/手機/Email"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1), _c('role-form', {
    ref: "form",
    attrs: {
      "role": _vm.role,
      "is-read-only": true
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-3"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.staffs,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm._f("hiddenString")(data.item.name, 20)) + " ")];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "id": "ddown23",
            "variant": "secondary"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "mdi mdi-menu"
        })]), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'OrganizationsStaffChangePassword',
              params: {
                role_id: _vm.role.id,
                staff_id: data.item.id
              }
            }
          }
        }, [_vm._v(" 變更密碼 ")]), _c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.simulateLogin(data.item);
            }
          }
        }, [_vm._v(" 模擬登入 ")])], 2)];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "to": _vm.getRoleListLink(),
      "variant": "outline-danger"
    }
  }, [_vm._v("返回 ")])], 1)], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "simulate-login",
      "footer-class": "d-flex justify-content-center",
      "hide-header": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "size": "lg",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('simulate-login');
            }
          }
        }, [_vm._v("關閉")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "swal2-icon swal2-warning swal2-animate-warning-icon",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "swal2-icon-text"
  }, [_vm._v("!")])]), _c('div', [_vm._v("切換帳號：" + _vm._s(_vm.selectedStaff.employee_code))]), _c('div', [_vm._v("登入網址："), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.generateLoginUrl
    }
  }, [_vm._v("重新產生")])], 1), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    staticClass: "mt-2",
    attrs: {
      "id": "simulate-login-url"
    },
    on: {
      "click": _vm.copySimulateLoginUrl
    },
    model: {
      value: _vm.simulateLoginUrl,
      callback: function callback($$v) {
        _vm.simulateLoginUrl = $$v;
      },
      expression: "simulateLoginUrl"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }